import React, { useState, useEffect } from "react";
import { __ } from "@wordpress/i18n";
const { withSelect } = wp.data;
import { PanelBody, TextControl, ToggleControl, TextareaControl } from "@wordpress/components";

import BControlPro from "../../../../components/BControlPro";

import { produce } from "immer";
import { useWPAjax } from "../../../../../../wp-utils/v1";
import generateUniqueID from "../../../../../../wp-utils/v1/generateUniqueId";

const PasswordProtected = ({ attributes, isPremium, updateFeatures, isSavingPost }) => {
  const { data, isLoading, error, saveData } = useWPAjax("save_password", { nonce: h5vpAdmin?.nonce, model: "Block", method: "save_password" });
  const { enabled, password, heading, key, errorMessage, button = {} } = attributes.features.passwordProtected || {};

  const [passwordVisible, setPasswordVisible] = useState(false);

  const onChange = (value) => {
    updateFeatures(
      produce(attributes.features.passwordProtected || {}, (draft) => {
        // draft.enabled = enabled;
        Object.keys(value).map((key) => {
          draft[key] = value[key];
        });
      }),
      "passwordProtected"
    );
  };

  useEffect(() => {
    if (!key) {
      onChange({ key: "h5vp_" + generateUniqueID("10") });
    }
  }, []);

  useEffect(() => {
    saveData({ key, password, quality: attributes.quality, source: attributes.source });

    // console.log("saving post", new Date().getMinutes());
  }, [isSavingPost]);

  // useEffect(() => {
  //   console.log(data, error);
  // }, [data, error, isLoading]);

  return (
    <PanelBody title={__("Password Protected", "h5vp")} initialOpen={false}>
      <BControlPro isPremium={isPremium} Component={ToggleControl} label={__("Password Protected", "h5vp")} checked={enabled} onChange={() => onChange({ enabled: !enabled })} />
      {enabled && (
        <>
          <div style={{ position: "relative" }}>
            <TextControl type={passwordVisible ? "text" : "password"} label={__("Password", "h5vp")} value={password} onChange={(password) => onChange({ password })} />
            <svg
              onClick={() => setPasswordVisible(!passwordVisible)}
              fill="#000000"
              width="20px"
              className="password_visible_icon"
              height="20px"
              viewBox="0 0 36 36"
              preserveAspectRatio="xMidYMid meet"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <title>{"eye-solid"}</title>
              <path
                d="M33.62,17.53c-3.37-6.23-9.28-10-15.82-10S5.34,11.3,2,17.53L1.72,18l.26.48c3.37,6.23,9.28,10,15.82,10s12.46-3.72,15.82-10l.26-.48ZM17.8,26.43C12.17,26.43,7,23.29,4,18c3-5.29,8.17-8.43,13.8-8.43S28.54,12.72,31.59,18C28.54,23.29,23.42,26.43,17.8,26.43Z"
                className="clr-i-solid clr-i-solid-path-1"
              />
              <circle cx={18.09} cy={18.03} r={6.86} className="clr-i-solid clr-i-solid-path-2" />
              <rect x={0} y={0} width={36} height={36} fillOpacity={0} />
            </svg>
          </div>

          <TextareaControl label={__("Heading", "h5vp")} value={heading} onChange={(heading) => onChange({ heading })} />
          <TextControl type="text" label={__("Password Incorrect message", "h5vp")} value={errorMessage} onChange={(errorMessage) => onChange({ errorMessage })} />
          <TextControl type="text" label={__("Button Text", "h5vp")} value={button?.text} onChange={(text) => onChange({ button: { ...button, text } })} />
        </>
      )}
    </PanelBody>
  );
};

export default withSelect((select) => {
  const { isSavingPost } = select("core/editor");
  return {
    isSavingPost: isSavingPost(),
  };
})(PasswordProtected);
